import { Button, ButtonOwnProps, DialogProps, Stack } from '@mui/material'
import Modal from '@/core/components/modal/Modal.tsx'
import { ReactNode } from 'react'
import LoaderIndicator from '@/core/components/loaderIndicator/LoaderIndicator.tsx'

interface Props {
  maxWidth?: string
  body: ReactNode
  cancelBtnText?: string
  onCancelAction?: () => void
  okBtnText?: string
  okBtnColor?: ButtonOwnProps['color']
  onOkAction?: () => void
  isOkLoading?: boolean
  isLoading?: boolean
  open?: boolean
}

const ActionModal = ({
  title,
  maxWidth,
  body,
  okBtnText = 'Aceptar',
  cancelBtnText = 'Cancelar',
  okBtnColor,
  onOkAction,
  onCancelAction,
  isOkLoading,
  isLoading,
  open = true
}: Props & Omit<DialogProps, 'open' | 'maxWidth'>) => {
  return (
    <Modal
      open={open}
      title={title}
      sx={{ '& .MuiDialog-paper': { maxWidth } }}
    >
      {isLoading ? (
        <LoaderIndicator sx={{ minHeight: '80px' }} />
      ) : (
        <Stack sx={{ p: 2 }} spacing={3}>
          <Stack spacing={1}>{body}</Stack>
          <Stack direction="row" spacing={2} justifyContent="end">
            <Button variant="outlined" onClick={() => onCancelAction?.()}>
              {cancelBtnText}
            </Button>
            <Button
              variant="contained"
              color={okBtnColor}
              onClick={() => onOkAction?.()}
              loading={isOkLoading}
            >
              {okBtnText}
            </Button>
          </Stack>
        </Stack>
      )}
    </Modal>
  )
}

export default ActionModal
